import { iconSizes, ToolTip } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import { ICatalog, IPriceOverride, IRestrictions } from "shared/hubrise/models"
import { refsToNames } from "shared/hubrise/utils/Variant"

import { Summary, Section, Line, ClickableIcon } from "./Styles"

interface VariantPriceTooltipProps {
  catalog: ICatalog
  navigateToGrid: () => void
  priceOverrides?: Array<IPriceOverride>
  restrictions: IRestrictions
}

const VariantPriceTooltip = ({
  catalog,
  navigateToGrid,
  priceOverrides,
  restrictions,
}: VariantPriceTooltipProps): JSX.Element | null => {
  const { t } = useTranslation()

  let priceOverrideSummary = null
  if (priceOverrides) {
    const lines: Array<JSX.Element> = []
    priceOverrides.forEach(({ variantRefs, price }, index) => {
      const variantNames = refsToNames(catalog, variantRefs || [])
      if (variantNames.length > 0) {
        lines.push(
          <Line key={index}>
            {variantNames.join(", ") + t("general.colon") + " "}
            <span dangerouslySetInnerHTML={{ __html: price.toHumanString() }} />
          </Line>,
        )
      }
    })
    if (lines.length > 0) priceOverrideSummary = <Section>{lines}</Section>
  }

  let restrictionsSummary = null
  if (restrictions.variantRefs !== undefined) {
    const variantNames = refsToNames(catalog, restrictions.variantRefs).join(", ")
    restrictionsSummary = variantNames ? (
      <Section>{t("variants.tooltip.enabled_for", { variantNames })}</Section>
    ) : (
      <Section>{t("variants.tooltip.disabled")}</Section>
    )
  }

  if (!priceOverrideSummary && !restrictionsSummary) return null

  const summary = (
    <Summary>
      {priceOverrideSummary}
      {restrictionsSummary}
    </Summary>
  ) as any as string

  return (
    <ToolTip label={summary} toolTipPlacement="south_west">
      <ClickableIcon code="layers" size={iconSizes._20} onClick={navigateToGrid} />
    </ToolTip>
  )
}

export default VariantPriceTooltip
